(function () {
  function pad(n) {
    return n < 10 ? "0" + n : "" + n;
  }

  function defaultTarget() {
    var now = new Date();
    var y = now.getFullYear();
    var t = new Date(y + "-09-01T00:00:00");
    if (now >= t) t.setFullYear(y + 1);
    return t;
  }

  function startTimer(el) {
    if (!el || el.__selloutStarted) return;
    el.__selloutStarted = true;

    var out = el.querySelector(".js-sellout-count");
    if (!out) return;

    var raw = el.getAttribute("data-deadline");
    var target = raw ? new Date(raw) : defaultTarget();

    function tick() {
      var diff = target - new Date();
      if (diff < 0) diff = 0;

      var days = Math.floor(diff / 864e5);
      var hours = Math.floor((diff % 864e5) / 36e5);
      var mins = Math.floor((diff % 36e5) / 6e4);
      var secs = Math.floor((diff % 6e4) / 1e3);

      out.textContent =
        days + ":" + pad(hours) + ":" + pad(mins) + ":" + pad(secs);

      if (diff > 0) el.__selloutTimer = setTimeout(tick, 500);
    }
    tick();
  }

  function init(ctx) {
    (ctx || document).querySelectorAll(".js-sellout").forEach(startTimer);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init();
  });
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });

  var obs = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      (m.addedNodes || []).forEach(function (n) {
        if (n.nodeType === 1) {
          if (n.matches && n.matches(".js-sellout")) startTimer(n);
          else init(n);
        }
      });
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
